<template>
  <div>
    <br />
    <br v-if="!mobile" />
    <!-- toolbar -->
    <p>
      <!-- title -->
      <span style="font-size: 25px">Lessons</span>

      <!-- create new lesson -->
      <button
        @click="operation = { operation: 'create' }"
        data-target="lesson"
        class="btn waves-effect waves-light indigo modal-trigger"
        style="float: right"
      >Add New</button>
    </p>
    <hr />

    <br />

    <ul v-show="levels.length > 0" class="collapsible">
      <li v-for="level in levels" :key="level._id">
        <div class="collapsible-header">Level {{ level.level }}</div>
        <div class="collapsible-body">
          <ul class="collection">
            <li
              v-for="(lesson, index) in level.lessons"
              :key="lesson.lesson"
              class="collection-item"
            >
              <span>{{ lesson.name }}</span>
              <i
                @click="operation = { operation: 'delete', id: level._id, lesson: lesson.lesson }"
                data-target="lesson"
                class="modal-trigger material-icons red-text"
                style="float: right"
              >delete</i>
              <i
                @click="operation = { operation: 'update', level, index }"
                data-target="lesson"
                class="modal-trigger material-icons green-text"
                style="float: right; margin-right: 20px"
              >edit</i>
            </li>
          </ul>
        </div>
      </li>
    </ul>

    <br v-for="i in 4" :key="i" />

    <!-- Modal Structure -->
    <div id="lesson" class="modal modal-fixed-footer">
      <div class="modal-content">
        <div v-if="operation.operation === 'delete'">
          <br />
          <br />
          <br />
          <h4 class="center red-text">Are you sure you want to delete this lesson</h4>
        </div>

        <form @submit.prevent="submit" v-else>
          <div class="row">
            <div class="input-field col s12">
              <input
                id="level"
                type="number"
                v-model="query.level"
                required
                :disabled="operation.operation !== 'create'"
                :style="operation.operation === 'create' ? '' : { 'cursor': 'not-allowed' }"
                class="validate"
              />
              <label for="level" :class="query.level ? 'active' : ''">Level Number</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12">
              <input id="name" type="text" v-model="query.name" required class="validate" />
              <label for="name" :class="query.name ? 'active' : ''">Lesson Name</label>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s12">
              <input id="lessonUrl" type="text" v-model="query.url" required class="validate" />
              <label for="lessonUrl" :class="query.url ? 'active' : ''">Lesson Url</label>
            </div>
          </div>
          <div class="row center">
            <button
              class="btn waves-effect waves-light indigo"
              :class="operation.operation === 'update' ? 'modal-close' : ''"
            >{{ operation.operation === 'create' ? 'Create' : 'Update'}}</button>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <a
          v-if="operation.operation === 'delete'"
          @click="deleteLesson"
          href="#!"
          class="modal-close waves-effect waves-light btn-flat"
        >Yes</a>
        <a
          href="#!"
          class="modal-close waves-effect waves-light btn-flat"
        >{{ operation.operation === 'delete' ? 'No' : 'close' }}</a>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      operation: {},
      levels: [],
      query: {
        id: "",
        level: "",
        name: "",
        lesson: 0,
        url: ""
      }
    };
  },
  created() {
    $(document).ready(() => {
      $(".collapsible").collapsible();
      $(".modal").modal();
    });

    this.$store
      .dispatch("getLessons")
      .then(response => (this.levels = response.data));
  },
  methods: {
    submit() {
      if (this.operation.operation === "create") {
        this.$store.dispatch("createLesson", this.query).then(response => {
          if (response.data.success) {
            this.$store
              .dispatch("getLessons")
              .then(response => (this.levels = response.data));

            M.toast({
              html: "transaction successful",
              classes: "green"
            });
          } else if (response.data.exist) {
            M.toast({
              html: "This lesson already exists",
              classes: "amber"
            });
          } else {
            M.toast({
              html: "There is a error",
              classes: "red"
            });
          }
        });
      } else {
        this.$store.dispatch("updateLesson", this.query).then(response => {
          if (response.data.success) {
            this.$store
              .dispatch("getLessons")
              .then(response => (this.levels = response.data));

            M.toast({
              html: "transaction successful",
              classes: "green"
            });
          } else if (response.data.exist) {
            M.toast({
              html: "This lesson already exists",
              classes: "amber"
            });
          } else {
            M.toast({
              html: "There is a error",
              classes: "red"
            });
          }
        });
      }
    },
    deleteLesson() {
      this.$store.dispatch("deleteLesson", this.operation).then(response => {
        if (response.data.success) {
          this.$store
            .dispatch("getLessons")
            .then(response => (this.levels = response.data));

          M.toast({
            html: "transaction successful",
            classes: "green"
          });
        } else {
          M.toast({
            html: "There is a error",
            classes: "red"
          });
        }
      });
    }
  },
  computed: {
    mobile() {
      return window.innerWidth < 420;
    }
  },
  watch: {
    operation() {
      if (this.operation.operation === "update") {
        this.query.id = this.operation.level._id;
        this.query.level = this.operation.level.level;
        this.query.name = this.operation.level.lessons[
          this.operation.index
        ].name;
        this.query.lesson = this.operation.level.lessons[
          this.operation.index
        ].lesson;
        this.query.url = this.operation.level.lessons[this.operation.index].url;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Lessons.vue